import el from 'element-ui/lib/locale/lang/zh-TW';

/* eslint-disable */
export default {
  app: {
    hi: ' 您好',
    name: 'Okubuy',
    login: '登入',
    logout: '登出',
    register: '註冊',
    reset_password: '重置密碼',
    default: '默認',
    create_account: '建立賬號',
    delete: '刪除',
    edit: '編輯',
    tips: '提示',
    confirm: '確定',
    cancel: '取消',
    save: '保存',
    view_more: '查看更多',
    view: '查看訂單',
    share: '分享',
    submit: '提交',
    no_limit: '不限',
    file_only_accept_jpg_png: '上傳文件只能是 jpg、png格式',
    file_size_only: '上傳圖片大小不能超過{size}',
    search: '搜索',
    reset: '重置',
    select_all: '全選',
    inputMoreThanWords: '輸入不能少於{0}個字符',
    please_login: '請先登錄賬號',
    submit_err: '提交失敗',
    delete_err: '刪除失敗',
    search_bar_placeholder: '输入商品或品牌名稱，搜索全場商品',
    loading: '正在加載中...',
    loading_captcha: '正在加載驗證碼...',
    currency: '貨幣',
    yes: '是',
    none: '否',
  },
  topbar: {
    faq: '常見問題',
    guide: '新手指南',
    exchange_rate: '參考匯率',
  },
  nav: {
    home: '首頁',
    shop: '商店',
    forwarding: '轉送',
    more_classify: '查看更多分類>>',
    proxy_request: '請求代購',
    product_promotion: '商品推介',
    straight: '直購',
    proxy_buy: '代購',
    new_product: '最新商品',
    off_price_product: '特價商品',
    hot_sales_product: '熱銷商品',
    recommend_product: '推薦商品',
    free_postage_product: '包郵商品',
    all_product: '所有商品',
  },
  faq: {
    most_popular_questions: '最熱門問題',
    account_registration: '會員註冊',
    making_purchase: '購買商品',
    package: '包裹入倉與發送',
    other_questions: '其它',
    answer_your_questions: '此FAQ是否有解答到您的疑問？ ',
    thankyou_for_your_feedback: '提交成功！非常感謝您的反饋，我們會繼續努力做到更好！ ',
    ask_us: '還沒有找到答案？問我們。 ',
    we_respond_within_2days: '我們通常會在2個工作日內回复。最熱門的問題將出現在此頁面上。 ',
    subject: '主題',
    your_name: '名稱',
    cellphone: '電話號碼',
    email: '郵箱',
    category: '分類',
    question: '問題',
    placeholder: {
      name: '填寫您的名稱',
      email: '填寫您的郵箱地址',
      category: '請選擇問題類型',
      question: '請填寫您的問題',
      subject: '請填寫您的主題',
      cellphone: '請填寫你的電話號碼',
    },
    rules: {
      name: '名稱不能為空',
      email: '郵箱地址不能為空',
      correct_email: '請填寫正確的郵箱地址',
      category: '請選擇問題類型',
      question: '問題不能為空',
      question_len: '問題至少輸入3個字符',
      subject: '主題不能為空',
    },
  },
  shop_names: {
    rakuten: 'Rakuten',
    yahoo_jp: 'YAHOO!JAPAN',
    amazon_jp: 'Amazon JP',
  },
  login: {
    page_title: '登入或建立帳號',
    registered: '已註冊？',
    login_tips: '如果您已有帳號，請登入',
    mobile_authenticated: '手機號碼已註冊？',
    mobile_tips: '請輸入手機號碼，以獲取短信驗證碼登入',
    remember_me: '記住我',
    forgot_password: '忘記密碼',
    placeholder: {
      account: '請輸入登錄賬號或郵箱',
      password: '請輸入登錄密碼',
      mobile: '請輸入已經註冊的手機號碼',
    },
    rules_message: {
      account_required: '請輸入登錄賬號或電郵',
      password_required: '請輸入登錄密碼',
      mobile_required: '請輸入手機號碼',
      mobile_error: '請輸入正確的手機號碼',
      captcha_required: '請輸入短信驗證碼',
    },
    accountLogin: '賬號登錄',
    smsLogin: '短信驗證碼登錄',
    thridPartyLogin: '第三方登錄',
    get_sms_captcha: '獲取驗證碼',
    sms_captcha: '短信驗證碼',
    resend: '重新發送',
    register: '註冊會員',
    un_regisered: '還未註冊?',
    register_tips: '註冊免費而快捷!',
    registered_infos: [
      '能夠快速結帳',
      '能夠登錄多個收貨地址',
      '能夠查看追蹤訂單狀態',
    ],
    login_fail: '登錄失敗',
  },
  reset: {
    send: '發送',
    reset: '重置密碼',
    email: '郵箱',
    password: '密碼',
    confirm_password: '確認密碼',
  },
  register: {
    page_title: '創建賬戶',
    register_tips: '輸入下列信息来創建您的賬戶',
    accepted: '同意并繼續',
    reject: '拒絕',
    read_and_accepted: '我已閱讀并同意',
    labels: {
      email: '電子郵箱',
      phone: '電話號碼',
      password: '密碼',
      password_confirmation: '確認密碼',
      referral_code: '介紹人會員號碼',
    },
    placeholder: {
      email: '請輸入電郵地址',
      phone: '請輸入您的電話號碼',
      password: '設置您的密碼，長度必須介乎 6 至 20 個字符之間',
      password_confirmation: '請再次確認您的密碼',
      referral_code: '填寫您的介紹人會員號碼，選填項',
    },
    rules_message: {
      email_type: '請輸入正確的電郵',
      email_required: '請填寫電郵地址',
      phone_required: '請填寫您的電話號碼',
      password_required: '請輸入登錄密碼',
      password_length: '長度必須介乎{min}至{max}個字符之間',
      password_confirmation_required: '請再次確認密碼',
      password_not_comfirmed: '兩次輸入的密碼不一致',
    },
  },
  activation: {
    thank_you_registered: '感謝您註冊{appname}',
    active_your_account: '請激活您的帳號',
    send_mail_tips: '我們已經發送郵件到您的電子郵箱:{email}，請按照郵件指示激活您的帳號',
    resend_link: '如果您沒有收到郵件，點擊這裡重新發送',
    activing: '正在激活您的賬戶...',
    activation_successed: '您的賬戶已激活，祝購物愉快！！',
    bind_successed: '綁定成功，祝購物愉快！！',
    activation_failed: '激活失敗',
  },
  user: {
    user_center: '會員中心',
    my_account: '我的賬戶',
    my_orders: '我的訂單',
    product_view_history: '我的足跡',
    lately_history: '最近足跡',
    lately_orders: '最近訂單',
    not_lately_orders: '最近沒有新的訂單',
    not_lately_history: '最近沒有新的足跡',
    not_lately_wishlist: '沒有收藏的商品',
    not_lately_ship: '沒有添加收貨地址',
    history_err: '獲取我的足跡失敗',
    information: '個人信息',
    wish_list: '我的收藏',
    shipping_address: '收貨地址',
    proxy_list: '代購請求',
    registration_in: '註冊與',
    last_login_time: '上次登錄時間',
    coupon: '我的優惠券',
    coupons: '優惠券',
    promotion: '推廣賺佣金',
    integral: '我的積分',
    generalize: '推廣等級',
    member: '會員等級',
    balance: '我的餘額',
    logout: '登出',
    order_detail: '訂單詳情',
    orders_err: '獲取訂單失敗',
    go_to_login: '去登入',
    added_to_wishlist: '已加入收藏夾',
    removed_wishlist: '已移出收藏夾',
    success: '修改成功',
    screen: '分類篩選',
    upload_img_err: '上傳頭像圖片大小不能超過 2MB!',
    type: '類型',
    content: '內容',
    time_limit: '期限',
    immediate_use: '立即使用',
    be_usable: '可使用',
    used: '已使用',
    expired: '已過期',
    no_coupons: '沒有可使用的優惠券'
  },
  guide: {
    registered_members: '註冊會員',
    buy: '如何購買',
    payment: '付款条件',
    charge: '代購商品收費',
    pay_attention: '注釋和條款',
    first: {
      one: '1：注册',
      two: '請點擊主頁右上角的「Register」(會員註冊)連結進入會員註冊網頁。點選註冊。',
      three: '2：設定用戶ID、密碼和填寫電郵地址',
      four: '用戶ID可以設定為電郵地址或電話號碼，並填寫一個有效的電郵地址以接收確認郵件。',
      five: '設定好用戶ID、密碼和電郵地址後，點擊「Submit」按鈕提交會員註冊申請。',
      six: '3：確認郵件',
      seven: '完成註冊後，請到您的註冊郵箱打開OKUBUY寄給您的郵件並「確認連結」進行帳號確認。\n' +
        '              當完成電郵地址確認後，會員帳號的登記手續就完成，可以使用這個帳號來購物。如果沒有收到郵件請查詢垃圾信箱。',
    },
    second: {
      one: 'OKUBUY直購',
      two: 'OKUBUY直購區刊登的商品皆為現貨商品，購買後可以快速寄出。付款完畢後如果商品已經在貨倉則於次日出貨。',
      three: '如果您有其他代購商品想合併寄出，可以在選擇寄送方式時點選「送到我的倉庫」。當代購商品抵達時，再使用合併包裹功能一起出貨。',
      four: '由於商品在付款完成後會直接進入購買流程，除非商品缺貨或是價格有波動, 否則無法取消訂單，購買前請先確認訂購之商品無誤。',
      five: '搜尋到欲購買的商品後，點擊「加入購物車」的按鈕。',
      six: '確認商品內容與合計金額。如資料無誤，點擊「結賬」按鈕。',
      seven: '確認好帳單地址後，請點擊「繼續」按鈕。',
      eight: '選擇配送方式後，請點擊繼續按鈕。',
      nine: '選擇支付方式與確認訂單內容後，請點擊「結賬」按鈕完成訂購。',
      ten: '完成訂購後，您可時隨時在「我的帳號」內的訂單頁面中查閱有關訂單的內容。在成功購買您訂購的商品後，OKUBUY將會發送電子郵件通知您。',
      eleven: 'Amazon或Ratuten代購',
      twelve: '只要在OKUBUY的首頁點選代購 —「Amazon亞馬遜」或「Ratuten樂天」，您在Amazon或Ratuten的購物籃商品會直接進入OKUBUY代購籃。',
      thirteen: '其他網站代購',
      fourteen: 'OKUBUY可以代購一些只可在品牌官網或其他商店才能購買的商品。請填寫「代購」表格，待訂單確認後付款.',
      fifteen: '由於商品在付款完成後會直接進入購買流程，除非商品缺貨或是價格有波動, 否則無法取消訂單，購買前請先確認訂購之商品無誤。',
    },
    third: {
      one: '付款方式',
      two: '接受Paypal, Payme, 微信，支付寶及銀行入賬付款。',
    },
    fifth: {
      one: '關於商品',
      two: '1. 貨品包裝單邊（長，闊或高）任何一邊不能超過 60cm，如果超過60cm必須按照體積重量收費。',
      three: '2. 貨品包裝總長（長加闊加高三邊總長）不能超過 120cm，如果超過120cm必須按照體積重量收費。',
      four: '配送方式',
      five: '貨到香港後，會以E-MAIL通知客戶到自提點取件（免費）或送貨上門（需額外收費）。',
    },
    fourth: {
      Calculation: '代購商品收費計算',
      country: ['','日本','美國','澳洲','英法德','韓國','泰國','台灣'],
      fee: ['手续费', '50', '50', '50', '50', '50', '50', '50'],
      internation: ['国际运费（每磅）', '25', '25', '25', '30', '25', '25', '25'],
      local: ['當地運費', '按代購網站／商店收費標準，實報實銷收費。'],
      price: ['商品價格', '商品價錢 ＆ 當日匯率'],
      localPrice: ['支付平台費用', '5%', '5%', '5%', '5%', '5%', '5%', '5%'],
    }
  },
  user_info: {
    personal: '修改資料',
    avatar_image: '上傳頭像',
    login_name: '登錄名',
    update_password: '修改密碼',
    old_password: '原始密码',
    new_password: '新密码',
    confirm_password: '確認密码',
    keep: '保存',
    actual_name: '真實姓名',
    can_only_be_changed_once: '登錄名只能修改一次',
    gender: '性別',
    male: '男',
    female: '女',
    secrecy: '未知',
    birthday: '生日',
    choose_birthday: '選擇日期',
    phone_number: '電話號碼',
    change_password: '密碼已修改成功',
  },
  order: {
    id: '訂單號',
    type: '訂單類型',
    quantity: '數量',
    amount: '金額',
    status: '訂單狀態',
    order_date: '下單日期',
    subtotal: '小計',
    name: '商品名稱',
    price: '價格',
    size: '尺碼',
    color: '顏色',
    shipping: '運費',
    tax: '稅',
    sale_tax: '消費稅',
    import_tax: '進口稅',
    total: '總計',
    total_tax: '含稅',
    payment: '立即付款',
    shipping_fee: '運費',
    local_shipping_fee: '本地運費',
    overseas_shipping_fee: '海外運費',
    handling_fee: '手續費',
    contains_shipping_fee: '含運費',
    order_detail: '訂單詳情',
    created_at: '下單時間',
    cancel_order: '取消訂單',
    filter_all: '所有訂單',
    filter_unpaid: '待付款',
    filter_delivered: '待發貨',
    filter_shipping: '待收貨',
    filter_uncomment: '待評價',
    filter_closed: '已關閉',
    filter_completed: '已完成',
    filter_wait_for_pickup: '待自提',
    filter_last_3_months: '最近3個月訂單',
    filter_last_6_months: '最近半年訂單',
    filter_input_placeholder: '搜索訂單號或者商品名',
    payment_method: '付款方式',
    payment_status: '付款狀態',
    payment_timeout_tips: '請在以下時間前付款，超時訂單自動關閉',
    wait_for_ship: '等待倉庫發貨',
    step1: '提交訂單',
    step2: '付款成功',
    step3: '商品發貨',
    step4: '訂單完成',
    step5: '評價',
    step6: '待付款',
    shipping_info: '收貨信息',
    shipping_method: '配送方式',
    payment_info: '付款信息',
    products: '訂單商品',
    total_product: '商品總價',
    total_price: '總價錢',
    order_closed: '超時訂單将自動關閉: ',
    successful_payment: '付款成功，等待賣家發貨',
    shipped: '商家已發貨，請注意收貨',
    comment: '買家已收貨，您可以對商品進行評價',
    suborder_splited_payment_tips: '該訂單屬於{main_order}的子訂單，請前往主訂單頁面進行付款，給您帶來的不便敬請諒解。',
    view_main_order: '查看主訂單',
    tracking_parcel: '追蹤包裹',
    comment_btn: '评价',
    commodity: '商品詳情',
    detail: '詳情',
    operating: '操作',
    change_payment_method: '更改支付方式',
    del_order: '取消訂單',
    buy_again: '再次購買',
    product_add_car: '是否把訂單商品重新加入購物車',
    view_logistics: '查看物流',
    to_pay: '去支付'
  },
  wish_list: {
    product_name: '商品名稱',
    wish_poduct: '收藏商品',
    wish_add_car: '加入購物車',
    clear_wish_list: '清空收藏列表',
    add_to_wish_list_err: '添加收藏夾失敗',
    remote_wish_list_err: '移除收藏夾失敗',
    confirm_clear_list: '確定清空列表嗎',
  },
  product: {
    none_specification: '沒有規格與包裝數據',
    none_comment: '沒有評論',
    none_advisories: '沒有諮詢',
    distribution: '配送提醒',
    id: '商品ID',
    product: '商品',
    name: '商品名稱',
    product_categories: '商品分類',
    detail: '詳細',
    price: '售價',
    old_price: '原價',
    unit_price: '單價',
    specification: '規格',
    brand: '品牌',
    unit_tax: '稅',
    original_price: '原價',
    total: '應付總價',
    quantity: '數量',
    subtotal: '小計',
    product_details: '商品詳情',
    upc: '商品編號',
    inventory: '庫存',
    availability: '可用性',
    description: '商品详情',
    comment: '評論',
    comment_has_number: '評論({0})',
    product_name: '商品名稱',
    weight: '重量',
    length: '長度',
    width: '寬度',
    height: '高度',
    specification_and_packaging: '商品图片',
    advisories: '咨詢',
    advisories_has_number: '咨詢({0})',
    comment_time: '評論時間',
    recovery_time: '回復時間',
    let_us_help_you_to_answer_your_doubts: '提出你的疑惑，讓我們來幫你解答',
    to_ask_questions: '提問',
    question: '問',
    answer: '答',
    no_answer: '暫無回答',
    advisory_err: '提問失敗',
    input_more_than4_words: '請輸入4個字以上',
    product_list: '商品列表',
    all_categories: '所有分類',
    load_more: '加載更多商品',
    load_more_error: '加載商品失敗，請稍後再試',
    tax_included: '含稅',
    stock_inform: '到貨通知',
    more: '更多>>',
    distribution_nonsupport: '不支持配送的國家或地區',
    serve: '服務',
    serve_content: '本商品由',
    shipments: '發貨',
    source: '來源地',
    delivery: '配送',
    pickup: '自提費',
    pickups: '订单满{price}免自提費',
    freight: '運費',
    freights: '訂單滿{price}免運費',
    estimated_time: '預計{time}天送達',
    authentic_guarantee: '正品保證',
    returns: '支持退換貨',
    in_stock: '現貨發售',
    authentic_guarantee_txt: 'OKUBUY承諾所售商品均為100％正品',
    returns_txt: '該商品售後7天有質量/缺件問題可申請售後，審核通過后即可退換貨',
    in_stock_txt: '商品均為現貨，正常48小時內發貨',
    not_returns: '不支持退換貨',
    not_returns_txt: '该商品不支持退換貨',
    product_upc: '商品UPC',
    coupon: '优惠券',
    restricted_purchase: '限購',
    hkTo: '香港倉 至 ',
  },
  product_list: {
    shop_categories: '商品分類',
    price_range: '價格範圍',
    filter: '過濾',
    filter_by_brand: '按品牌過濾',
    filter_by_source: '按來源地過濾',
    list_page_total: '共{0}個商品',
    sort_by: '排序',
    sort_by_index: '綜合',
    price: '價格',
    sort_by_new: '上架時間',
    search_keyword: '搜索關鍵字',
    brand: '品牌',
    loading_goods: '正在加載更多商品',
    loading_goods_not: '沒有更多商品',
  },
  shipping_address: {
    add_address: '添加新地址',
    consignee: '收貨人',
    mobile: '移動電話',
    phone: '固話',
    email: '電郵',
    district: '地區',
    zip_code: '郵編',
    address: '地址',
    line1: '詳細地址1',
    line2: '詳細地址2',
    company: '公司',
    additional_information: '结账信息',
    set_default: '默認',
    confirm_delete: '確定要刪除該收貨地址嗎？',
    deleted: '收貨地址已刪除',
    label: '地址標籤',
    label_placeholder: '建議填寫常用名稱',
    reference_name: '參考名稱',
    my_home: '家庭',
    apartment: '公寓',
    parents_home: '父母家',
    express_box: '快遞柜',
    school: '學校',
    warehouse: '倉庫',
    hostel: '旅店',
    consignee_placeholder: '填寫收貨人姓名',
    zip_code_placeholder: '填寫郵政編碼',
    email_placeholder: '接收訂單物流信息郵件',
    company_placeholder: '填寫公司名稱',
    mobile_placeholder: '填寫移動電話號碼',
    area_code: '區號',
    phone_placeholder: '（區號）固話號碼',
    select_district: '請選擇收貨地址地區',
    address_placeholder: '建議您如實填寫詳細收貨地址，例如街道名稱，門牌號碼，樓層和房間號等信息',
    additional_information_placeholder: '',
    confirm_close_dialog: '收貨地址還沒有保存，確定關閉？',
    edit_address: '編輯地址',
    required_field_no_compltet: '帶*號為必填項，請填寫完整',
    address_has_been_save: '地址已保存',
    tracking_number: '跟蹤號碼',
    zipcode: '郵編',
    rules: {
      label_reduired: '請填寫地址標籤，以方便您的使用',
      consignee_reduired: '請填寫收貨人姓名',
      zipcode_required: '請填寫郵政編碼',
      email_reduired: '請填寫電子郵箱',
      email: '請填寫正確的郵箱地址',
      mobile_reduired: '請填寫您的電話號碼',
      selectedDistricts_reduired: '請選擇收貨地址的地區',
      line1_required: '請輸入您的收貨地址',
    },
  },
  area: {
    China: '中國大陸',
    HongKong: '香港',
    Macau: '澳門',
    TaiWan: '台灣',
    US: '美國',
    France: '法國',
    UK: '英國',
    Germany: '德國',
    Malaysia: '馬來西亞',
    Australia: '澳洲',
    NewZealand: '紐西蘭',
    Singapore: '新加坡',
    Thailand: '泰國',
    Japan: '日本',
    Korea: '韓國',
    VietNam: '越南',
    Cambodia: '柬埔寨',
  },
  footer: {
    contacts: '諮詢',
    contact_us: '聯絡我們',
    phone: '電話',
    monday_friday: '週一至五',
    customer_service: '客戶服務',
    faq: '常見問題',
    delivery: '配送安排',
    payment_method: '付款方法',
    information: '資訊',
    news: '最新消息',
    terms_and_conditions: '條款及條件',
    privacy_policy: '私隱政策',
    about_us: '聯絡我們',
    my_account: '我的賬戶',
    contact_us_me: '與我們聯繫',
    subscription: '訂閱',
    show_map: '顯示地圖地址',
    subscribe: '訂閱我們的通訊，以接收早期的折扣優惠，最新消息，銷售和宣傳信息。',
  },
  article: {
    release_time: '發佈時間',
    warehousing_and_delivery: '包裹入倉與發送',
    ask_us: '還沒有找到答案？問我們',
    we_normally_respond: '我們通常會在2個工作日內回复。最常見的問題將出現在此頁面上。 ',
    your_name: '您的名稱',
    category: '分類',
    question: '問題',
    placeholder: {
      name: '填寫您的名稱',
      category: '請選擇問題類型',
      question: '寫下您的問題',
    },
  },
  home: {
    featured_products: '精選商品',
    sale_products: '特價商品',
    top_sellers: '熱銷商品',
    new_arrivals: '最新商品',
    recommend_products: '推薦商品',
    popular_brands: '熱門品牌',
    shipping: '免費送貨',
    shipping_detailed: '所有超過100美元的訂單免運費',
    money_back: '退款保證',
    money_back_detailed: '我們會在30天内退貨',
    customer_support: '全天候客戶支持',
    customer_support_detailed: '友好的全天候客戶支持',
    secure_online_payment: '安全在線支付',
    secure_online_payment_detailed: '我們擁有SSL/安全證書',
  },
  cart: {
    add_to_cart: '添加到購物車',
    cart: '購物車',
    view_cart: '查看購物車',
    price: '單價',
    checkout: '結算',
    no_login_tips: '登入后購物車的商品將保存到您的賬號中',
    continue_shipping: '繼續購物',
    operation: '操作',
    remove: '刪除',
    add_to_wishlist: '收藏商品',
    added_to_wishlist: '已收藏',
    delete_wislist: '已取消收藏',
    defeated_delete_wislist: '取消收藏失敗',
    product_has_been_removed: '商品已從購物車中移除',
    product_has_benn_removed_to_wishlist: '商品已經移到收藏夾',
    product_move_to_wishlist_and_remove_cart: '商品移到收藏夾并移除購物車',
    update_to_cart_err: '更新購物車失敗',
    empty_cart_tips: '您的購物車沒有商品',
    total_product: '商品總價',
    total_tax: '稅總計',
    add_to_cart_err: '加入購物車失敗',
    update_cart_err: '更改購物車失敗',
    it_is_cheaper: '價錢比之前便宜了',
    it_is_expensive: '價錢比之前貴了',
    remove_err: '移除失敗',
    add_to_cart_success: '成功加入購物車',
  },
  redemption_center: {
    name: '自提點',
    district: '地區',
    address: '地址',
    phone: '電話',
    business_hours: '營業時間',
  },
  order_pay: {
    pay_id: 'PAY ID',
    amount: '金額',
    pay_time: '付款時間',
  },
  checkout: {
    to_pay: '支付',
    product: '商品',
    unit_price: '單價',
    unit_tax: '稅',
    sale_tax: '消費稅',
    import_tax: '進口稅',
    merchandise_news: '商品信息',
    remarks: '輸入備註信息',
    quantity: '數量',
    price: '價錢',
    additional_information: '額外信息',
    billing_information: '結算信息',
    shipping_methods: '配送方式',
    self_pick_up: '自提點取件',
    district_only_hk: '暫時只支持配送香港地區',
    courier: '快遞',
    self_point_address: '自提點地址',
    shipping_address: '收貨地址',
    add_shipping_address: '新增收貨地址',
    payment_method: '付款方式',
    logistics_type: '物流類型',
    logistics_fee: '費用',
    logistics_estimated_time: '預計時效',
    logistics_type_1: '特快服務',
    logistics_type_2: '專線快遞',
    logistics_type_3: '標準服務',
    free_postage_tips: '提示：訂單滿{price}免快递费',
    free_pick_up_tips: '提示：訂單滿{price}免自提费',
    area_group_diffent_tips: '根據您的收貨地址，系統將自動成收貨地使用貨幣結算',
    audit_order: '審核訂單',
    order_created: '已創建訂單',
    prev: '上一步',
    next: '下一步',
    back_to_cart: '回到購物車',
    your_cart_is_empty: '您的購物車沒有商品',
    go_to_shopping: '去購物',
    submit_orders: '提交訂單',
    picker: '取件人',
    phone: '手機號碼',
    consignee_form_validate_error: '請填寫正確的取件人信息',
    placeholders: {
      name: '取件人姓名，用於取件時核對',
      phone: '取件密碼將會發送到該手機號碼，請確保該號碼可收取短信',
    },
    rules: {
      picker_required: '請填寫取件人姓名',
      phone_required: '請填寫取件人的電話，取件密碼將會發送到該手機號碼',
    },
    checkout_fail: '結賬失敗',
    get_self_point_address_err: '獲取自提點失敗',
    get_shipping_address_err: '獲取收貨地址失敗',
    please_select_checkout_item: '請選擇要結賬的商品',
    order_split_tips: '您訂單中的商品在不同的倉庫，需要拆分訂單分開配送，給您帶來的不便敬請諒解。',
    please_input_promote_code: '請輸入你的優惠代碼',
    promote_code_placeholder: '輸入優惠代碼',
    promo_code: '優惠碼',
    Remote_areas: '住宅或偏遠地址附加費HKD $20，由司機上門額外收取，如拒付住宅或偏遠地址附加費導致派件失敗，客戶需額外支付二次派送費用',
    none: '不使用',
    day: '天',
  },
  shipping_fee: {
    free_postage_condition: '滿{price}免快遞費',
    desc_1: '不滿加收運費{price}',
    free_pick_up_price: '满{price}免自提费',
    pick_up_price: '不满加收自提费{price}',
    desc_2: '首重{first_weight}{weight_unit} {first_weight_price}，續重每{add_weight}{weight_unit} {add_weight_price}',
    additional_fees: '附加費用',
    import_tax: '進口稅',
    sale_tax: '消費稅',
  },
  proxy_request: {
    code: '編號',
    contact_phone: '聯繫電話',
    product_name: '商品名',
    product_url: '商品URL',
    image: '圖片',
    price: '參考價格',
    quantity: '數量',
    size: '型號/尺寸',
    color: '顏色',
    remark: '備註',
    created_at: '日期',
    status: '狀態',
    click_upload: '點擊上傳',
    placeholders: {
      contact_phone: '請留下您的聯繫電話，以便客服確認您的代購商品',
      product_name: '輸入您所需要代購的商品名',
      product_url: '輸入您需要代購的商品的URL',
      price: '以HKD為貨幣單位的商品參考價格，實際交易價格以訂單為準',
      size: '如果商品頁面中含有多款型號/尺寸，請輸入你所需要的型號/尺寸',
      color: '如果商品頁面中含有多款顏色，請輸入你所需要的顏色',
    },
    rules: {
      contact_phone_required: '請留下您的聯繫電話，以便客服確認您的代購商品',
      product_name_required: '請填寫商品名稱',
      product_url_required: '請填寫購物網站的URL',
      product_url: '請填寫正確的URL地址，以http://或https://開頭',
      price_required: '請填寫商品價格',
      quantity_required: '請填寫代購商品數量',
      shipping_method_required: '請選擇配送方式',
      redemption_center_id_required: '請選擇自取點',
      address_id_required: '請選擇收貨地址',
      payment_method_required: '請先用paypal付款',
    },
    please_add_shipping_address: '請先添加收貨地址',
    not_found: '沒有該代購請求',
    updated: '您的代購請求已修改',
    created: '已提交您的代購請求',
    canceled: '您的代購請求已取消',
    reject: '您的代購請求被拒絕',
    reject_reason: '拒絕原因',
    cancel: '取消',
    cancel_tips: '您確定要取消這個代購請求嗎？',
  },
  rakuten: {
    product_detail: '樂天商品',
    product_info: '商品信息',
    tax_include: '含稅',
    view_item_from_rakuten: '閱覽樂天頁面',
    shop_name: '店铺名稱',
    item_code: '商品代码',
    category: '分類',
    tag: '標籤',
    review_count: '評價數',
    review_count_text: '{0}個商品評論',
    review_average: '綜合評價',
    shipping_tips: '若商品屬於違禁品或禁止販售至海外的商品均有可能無法通關。我們將取消此類商品的訂單。敬請見諒。',
  },
  yahoo: {
    product_detail: '雅虎商品',
    view_item_from_yahoo: '閱覽雅虎頁面',
    shop_name: '店铺名稱',
    item_code: '商店代碼',
    review_count: '評價數',
    review_count_text: '{0}個商品評論',
    review_average: '綜合評價',
    category: '分類',
    product_info: '商品信息',
    view_review: '查看評價',
    shipping_tips: '若商品屬於違禁品或禁止販售至海外的商品均有可能無法通關。我們將取消此類商品的訂單。敬請見諒。',
  },
  amazon: {
    product_detail: '亞馬遜商品',
  },
  information: {
    information: '資訊',
    news: '最新消息',
    terms_and_conditions: '條款及條件',
    privacy_policy: '私隱政策',
    about_us: '聯絡我們',
  },
  facebook_pannel: {
    homepage: 'facebook主頁',
    line1: '讃好我們的facebook賬號',
    line2: '您可以在這裡了解到Okubuy的最新消息',
  },
  transportation: {
    parcel_list: '郵包列表',
    warehouses: '倉庫地址',
    parcel_information:'請輸入網站發貨的貨倉地址、快遞公司、追蹤號碼、貨件資料去確認貨件',
    parcel_screen: '郵包篩選',
    goods_name:'貨品名',
    valuation_fee:'保價費用(HKD)',
    parcel_describe:'郵包內含物描述',
    parcel_status: '郵包狀態',
    track_num :'追蹤號碼',
    ware: '貨倉',
    weight_pounds: '重量(磅)',
    courier_tracknum: '快遞公司 / 追蹤號碼',
    new_status: '最新狀態',
    product_details: '貨品詳情 / 貨值',
    push_parcel: '主動推送郵包',
    cancel_record: '取消記錄',
    completion_information:'補全信息',
    addgoods: '添加商品',
    send_out: '送出',
    placeholder:{
      choose: '请选择',
      warehouse_courier:'選擇倉庫地址及快遞公司',
      status:'请选择狀態',
      warehouses: '请选择倉庫',
      tracking_num: '请輸入追蹤號碼' ,
    },
    label: {
      warehouse_courier: '倉庫地址及快遞公司',
      tracking_num: '追蹤號碼',
      unit: '單位'
    },
  },
  pickup_point_selector: {
    pickups: '自提點',
    post_office: '郵政局',
	post_locker: '智郵站',
	ok: 'OK便利店',
	cainiao_locker: '菜鳥智能櫃',
    address: '地址',
  },
  validate: {
    mobile: '請輸入正確的電話號碼',
    fixline: '請輸入正確的電話號碼',
  },
  remove: {
    a: '初級會員',
    b: '初級推廣員',
  },
  payment: {
    paypal: 'PayPal',
    alipay: '支付寶',
    wechatpay: '微信支付',
    go_to_alipay_website_for_payment: '前往支付寶網站付款',
    use_alipay_app_scan: '使用支付寶APP"掃一掃"付款',
    use_fps_scan: '扫碼付款',
    use_wechat_app_scan: '使用微信"掃一掃"付款',
    pay_with_alipay: '支付寶付款',
    payment_error: '支付遇到錯誤，請聯繫客服。',
    has_the_payment_been_completed: '已完成支付？',
    pay: '付款',
    checkout_counter: '收銀台',
    sub_order1: '请您在提交订单后',
    sub_order2: '内完成支付，否则订单会自动取消'
  },
  comment: {
    order_evaluation: '訂單評價',
    order_number: '訂單編號',
    product_rating: '商品評分',
    product_review: '商品評價',
    commodity_order: '商品曬單',
  },
  state: {
    choose_your_country_or_region: '選擇你的國家或地區',
    africa_middle_east_and_india: '非洲、中東和印度',
    asia_pacific: '亞太地區',
    europe: '歐洲',
    latin_america_and_the_caribbean: '拉丁美洲和加勒比地區',
    the_united_states_canada_and_puerto_rico: '美國，加拿大和波多黎各',
  },
  tracking_statuses: {
    1: '新建訂單',
    2: '已到達自取點',
    3: '已發SMS通知客人取貨',
    4: '客人已經取貨',
    10: '預報',
    11: '攬收',
    12: '運輸中',
    13: '派件中',
    14: '已簽收',
    15: '投遞失敗',
    16: '其他',
    17: '收件',
    18: '到件',
    19: '客人簽收',
    20: '問題件',
  },
  ...el,
}
